import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme, isWideWeb = false) =>
  StyleSheet.create({
    container: {
      width: '100%',
      // Mobile/natif : on garde le comportement d'origine (le bloc bouton est
      // poussé en bas). Web large : le contenu ne s'étire plus sur toute la
      // hauteur (il est centré par ScreenAuth), ce qui supprime le grand vide.
      ...(isWideWeb
        ? { flex: 0 }
        : { flex: 1, justifyContent: 'space-between' }),
    },
    buttonContainer: {
      alignItems: 'center',
      paddingBottom: theme.spacing.md,
      // Web large : espace mesuré au-dessus du bouton (au lieu de le coller tout
      // en bas). Mobile inchangé.
      ...(isWideWeb
        ? { marginTop: theme.spacing.xxxl }
        : { flex: 1, justifyContent: 'flex-end' }),
    },
    emailInput: {
      paddingTop: theme.spacing.xxxl,
      marginBottom: theme.spacing.sm,
    },
    forgotPassowrd: {
      alignSelf: 'flex-end',
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.md,
    },
    noAccount: {
      paddingTop: theme.spacing.lg,
      marginBottom: theme.spacing.xxxl, 
    },
  })
